import './sentry'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import { esES, enUS } from '@clerk/localizations'
import App from './components/App'
import './i18n'
import './index.css'

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// Match the Clerk modal language to the user's bluaIQ language choice.
// `bluaiq-lang` is the canonical key (see CLAUDE.md — persisted by the landing
// language toggle); `i18nextLng` is the i18next default fallback.
function pickClerkLocalization() {
  const lang =
    localStorage.getItem('bluaiq-lang') ||
    localStorage.getItem('i18nextLng') ||
    (typeof navigator !== 'undefined' ? navigator.language : 'es')
  return lang.toLowerCase().startsWith('es') ? esES : enUS
}

// Brand tokens applied across all Clerk-hosted UI (sign-in, sign-up modals,
// user profile, etc). Keep in sync with tailwind.config.ts brand palette.
const clerkAppearance = {
  variables: {
    colorPrimary: '#06539B',
    colorText: '#1C1A17',
    colorTextSecondary: '#9E9890',
    colorBackground: '#FFFFFF',
    colorInputBackground: '#FFFFFF',
    colorInputText: '#1C1A17',
    borderRadius: '0.75rem',
    fontFamily: '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
  },
  elements: {
    formButtonPrimary:
      'bg-[#06539B] hover:bg-[#14457E] text-white font-bold rounded-full',
    footerActionLink: 'text-[#06539B] hover:text-[#14457E] font-bold',
    card: 'shadow-xl rounded-2xl border border-[#ECEAE4]',
    headerTitle: 'text-[#1C1A17] font-black',
    headerSubtitle: 'text-[#9E9890]',
    socialButtonsBlockButton:
      'border border-[#ECEAE4] rounded-lg hover:bg-[#FAFAF8]',
  },
}

const root = ReactDOM.createRoot(document.getElementById('root')!)

if (clerkKey) {
  root.render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={clerkKey}
        localization={pickClerkLocalization()}
        appearance={clerkAppearance}
      >
        <App />
      </ClerkProvider>
    </React.StrictMode>
  )
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
